export const getCommunityPostUrl = (postId, origin = "") => {
  const safePostId = encodeURIComponent(String(postId || ""));
  const base =
    origin ||
    (typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "");

  return `${base}/community${safePostId ? `?post=${safePostId}` : ""}`;
};
